import React, { useState } from "react";
import { CalcRangeSelector } from "../CalcRangeSelector";
import { CalcInput } from "../CalcInput";
import { deleteNulls } from "../../../helpers/helpers";

export const LoanSelector = ({ selected, items = [], onSelect }) => {
  const [value, setValue] = useState(selected);
  return (
    <>
      <li className="item">
        <label htmlFor="item-input-loan-amount" className="label">
          Сумма займа
        </label>
        <CalcInput
          id="item-input-loan-amount"
          maxLength={7}
          selected={selected}
          tempSelected={value}
          items={items}
          formatValue={(v) => (v ? deleteNulls(String(v.number)) : "")}
          onSelect={onSelect}
        />
        <div className="rub">₽</div>
      </li>
      <li className="item progressbar">
        <CalcRangeSelector
          selected={selected}
          items={items}
          onChange={(item) => setValue(item)}
          onSelect={onSelect}
        />
      </li>
    </>
  );
};
